<template>
  <div>
    <div class="d-flex justify-space-between align-center mt-2 px-4">
      <div class="font-size-big font-weight-bold my-2">{{ $translate("HomeScreenSection.myGroups") }}</div>
      <the-button text small :active="false" :to="{ name: $routes.SEARCH, params: { mode: 'groups' }, query: { suggested: 'true' } }">
        {{ $translate("common.findMore") }}
      </the-button>
    </div>
    <list-item-wrapper v-for="group in displayedGroups" :key="group.key" :to="{ name: $routes.GROUPS, params: { groupId: group.key } }">
      <template #image>
        <v-img v-if="group.imageUrl" :src="group.imageUrl" cover :aria-label="$translate('common.ariaGroupImage')" class="group-image rounded-app" />
      </template>
      <template #content>
        <div>{{ group.name }}</div>
      </template>
    </list-item-wrapper>
    <the-button
      v-if="folded && maxItemsBeforeFold && userGroupsWithoutCourseGroups.length > maxItemsBeforeFold"
      text
      block
      custom-colors
      class="see-more mt-2 color-wall-text"
      @click="folded = !folded"
    >
      <div class="d-flex align-center gap-2 font-weight-normal">
        <i-custom-arrow-down-thin />
        <span>{{ $translate("common.seeMore") }}</span>
      </div>
    </the-button>
  </div>
</template>

<script>
import { mapGetters } from "pinia"
import { useGroupsStore } from "@/store/groups.js"

import ListItemWrapper from "@/components/ListItemWrapper.vue"

export default {
  components: {
    ListItemWrapper
  },
  data() {
    return {
      folded: true,
      maxItemsBeforeFold: 5
    }
  },
  computed: {
    ...mapGetters(useGroupsStore, ["userGroupsWithoutCourseGroups"]),
    displayedGroups() {
      return this.folded ? this.userGroupsWithoutCourseGroups.slice(0, this.maxItemsBeforeFold) : this.userGroupsWithoutCourseGroups
    }
  }
}
</script>

<style lang="scss" scoped>
.group-image {
  width: 84px;
  max-width: 84px;
  height: 56px;
}

.see-more {
  :deep(.v-btn__content) {
    justify-content: flex-start;
  }
}
</style>
